// extracted by mini-css-extract-plugin
var _1 = "t2KC";
var _2 = "t2KD";
var _3 = "t2KE";
var _4 = "t2KF";
export { _1 as "accordion", _2 as "asterix", _3 as "container", _4 as "label" }
